import { render, staticRenderFns } from "./ProjectReport.vue?vue&type=template&id=fe027a48"
import script from "./ProjectReport.vue?vue&type=script&lang=ts"
export * from "./ProjectReport.vue?vue&type=script&lang=ts"
import style0 from "./ProjectReport.vue?vue&type=style&index=0&id=fe027a48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports